import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import MaterialTable from 'material-table'
import { Edit, Close, Check, Remove } from '@material-ui/icons'
import { acSetNofiticationsModal, acGetAllValidNotifications } from '../../../class/actions'
import { EditNotificationModal, RemoveNotificationModal } from '../../modal'
import { dateFormat, dateFormatToPicker } from '../../../class/utils'
import { DB_CONST } from '../../../class/constants'
import { Loader } from '../../default'

function TableNotification({
    currentNofificationsModal, notifications
}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const [selectedNotification, setSelectedNotification] = useState(null)

    useEffect(() => {
        dispatch(acGetAllValidNotifications())
            .catch(err => console.error(err))
    }, [dispatch])

    const prepareColumns = () => {
        return [
            { title: t('modals.notifications.manage.table.columns.id'), field: 'id', width: '3%' },
            { title: t('modals.notifications.manage.table.columns.created_at'), field: 'created_at', width: '18%' },
            { title: t('modals.notifications.manage.table.columns.valid_until'), field: 'valid_until', width: '18%' },
            { title: t('modals.notifications.manage.table.columns.type'), field: 'type', width: '15%' },
            { title: t('modals.notifications.manage.table.columns.link'), field: 'link', width: '3%' },
            { title: t('modals.notifications.manage.table.columns.filter'), field: 'has_filter', width: '3%' },
            { title: t('modals.notifications.manage.table.columns.message'), field: 'message' }
        ];
    }

    const prepareData = () => {
        if (!notifications) {
            return []
        }

        return notifications.map(notification => {
            return {
                id: notification.notification_id,
                created_at: dateFormat(notification.createdAt),
                valid_until: dateFormat(notification.valid_until),
                valid_until_edit: dateFormatToPicker(notification.valid_until),
                type_id: notification.notification_type_id,
                type: t(`modals.notifications.manage.table.type.${notification.notificationType.type}`),
                message: notification.message,
                link: notification.redirect_url ? <Check /> : <Remove />,
                link_edit: notification.redirect_url,
                has_filter: notification.filter_id !== 1 ? <Check /> : <Remove />,
                filter: notification.filter_id
            }
        })

    }

    const editNotification = notificationToBeEdited => {
        setSelectedNotification(notificationToBeEdited)
        dispatch(acSetNofiticationsModal(DB_CONST.NOTIFICATION_MODALS.EDIT))
    }

    const removeNotification = notificationToBeRemoved => {
        setSelectedNotification(notificationToBeRemoved)
        dispatch(acSetNofiticationsModal(DB_CONST.NOTIFICATION_MODALS.REMOVE))
    }

    return (
        <>
            {
                selectedNotification && (
                    <>
                        <EditNotificationModal
                            open={currentNofificationsModal === DB_CONST.NOTIFICATION_MODALS.EDIT}
                            onClose={() => dispatch(acSetNofiticationsModal(null))}
                            notificationToBeEdited={selectedNotification}
                        />

                        <RemoveNotificationModal
                            open={currentNofificationsModal === DB_CONST.NOTIFICATION_MODALS.REMOVE}
                            onClose={() => dispatch(acSetNofiticationsModal(null))}
                            notificationToBeRemoved={selectedNotification}
                        />
                    </>
                )
            }
            {
                notifications ? (
                    <MaterialTable
                        title={t('modals.notifications.manage.title')}
                        columns={prepareColumns()}
                        data={prepareData()}
                        localization={t('materialTableLocale', { returnObjects: true })}
                        actions={[
                            {
                                icon: () => (<Edit />),
                                tooltip: t('modals.notifications.manage.table.options.edit'),
                                onClick: (_, rowData) => {
                                    editNotification(rowData)
                                }
                            },
                            {
                                icon: () => (<Close />),
                                tooltip: t('modals.notifications.manage.table.options.close'),
                                onClick: (_, rowData) => {
                                    removeNotification(rowData)
                                }
                            }
                        ]}
                    />
                ) : <Loader />
            }
        </>
    )
}

TableNotification.propTypes = {
    notifications: PropTypes.array,
}

TableNotification.defaultProps = {
    notifications: []
}

const mapStateToProps = ({ ReducerNotification }) => ({
    currentNofificationsModal: ReducerNotification.currentNofificationsModal,
    notifications: ReducerNotification.notifications
})

export default connect(mapStateToProps)(TableNotification)